import React from 'react';
import { Email, InputGroupWrapper, Telefono } from '.';

interface Props {
	requiredTelefono?: boolean;
	requiredEmail?: boolean;
	hidePrefijo?: boolean;
}

export const TelefonoEmail = (props: Props) => {
	return (
		<InputGroupWrapper className="telefono-email-wrapper">
			<Telefono
				required={props.requiredTelefono}
				hidePrefijo={props.hidePrefijo}
			/>
			<Email required={props.requiredEmail} />
		</InputGroupWrapper>
	);
};
